module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/solothurn-2ecfc71953365c8e747ccb8032eb8ac8.png";